<yt-chart
    [ValueColumnName]="'Ukupno'"
    [LabelColumnName]="'Date'"
    [Type]="'bar'"
    [Data]="dataSource"
    [Series]="('HOME.DIAGRAM.FAKTURISANO' | translate) + ',' + ('HOME.DIAGRAM.TROSKOVI' | translate) + ',' + ('HOME.DIAGRAM.DUGUJE' | translate) + ',' + ('HOME.DIAGRAM.POTRAZUJE' | translate)"
    [Width]="1270"
    [Height]="300">
</yt-chart>